import React, { useContext, useMemo } from 'react';
import {
  Animated,
  StyleSheet,
  Platform,
} from 'react-native';


import { DragAndDropContext } from '../contexts/DragAndDropContext';
import DraggableFlatListRow from './DraggableFlatListRow';
import { ScrollViewContext } from '../contexts/ScrollViewContext';


const styles = StyleSheet.create({
  draggedItem: {
    zIndex: 99,
    position: 'absolute',
    left: 0,
    top: 0,
    backgroundColor: 'white',
    width: '100%',
  },
});

const interpolations = {
  scale: {
    inputRange: [0, 0.75, 1],
    outputRange: [1, 1, 1.1],
  },
  opacity: {
    inputRange: [0, 0.4, 0.5, 1],
    outputRange: [0, 0, 1, 1],
  },
};

const DraggedItem = () => {
  const {
          draggedAnimation, animatedDrag, draggedY,
        } = useContext(DragAndDropContext),
        { contentOffset } = useContext(ScrollViewContext);

  return useMemo(() => animatedDrag && animatedDrag.item
    ? (

      <Animated.View
        style={[
          styles.draggedItem,
          {
            opacity: draggedAnimation.interpolate(interpolations.opacity),
            transform: [
              { translateY: Platform.OS === 'web' ? Animated.add(draggedY, contentOffset.current.y) : draggedY },
              { scaleX: draggedAnimation.interpolate(interpolations.scale) },
              { scaleY: draggedAnimation.interpolate(interpolations.scale) },
            ],
          }]}
        testID='draggedItem'
      >
        <DraggableFlatListRow
          isDragged
          index={animatedDrag.index}
          item={animatedDrag.item}
        />
      </Animated.View>
    ) : null, [animatedDrag, contentOffset, draggedAnimation, draggedY]);
};


export default DraggedItem;
